import React from 'react';
import { motion } from 'framer-motion';
import {
  FaLinkedin,
  FaGithub,
  FaTwitter,
  FaFacebook,
  FaInstagram,
} from 'react-icons/fa';

const teamMembers = [
  {
    name: 'Abu-Bakkar Sajid',
    role: 'CEO/Founder ',
    role2: 'Full Stack Developer / web-app',
    image: '/abubakkar.jpg',
    socials: {
      linkedin: 'https://www.linkedin.com/in/dev-abubakkar-sajid?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3B%2Blo43eDiRUad%2FlH93Nfj6Q%3D%3D',
      github: 'https://github.com/Innocent-Developer',
      twitter: 'https://x.com/SajidAbuba74138',
      facebook: 'https://www.facebook.com/devabubakkarsajid',
      instagram: 'https://www.instagram.com/dev_abubakkar/',
    },
  },
  {
    name: 'Muhammad Iqbal Khan',
    role: 'CO-Founder',
    role2: 'Mobile App Developer',
    image: '/iqbal.jpeg',
    socials: {
      linkedin: 'linkedin.com/in/devmuhammadiqbal',
      github:'https://github.com/dev-iqbal-khan',
      facebook: 'https://www.facebook.com/Muhammadiqbalkhanmeerdadkhail',
    },
  },
  {
    name: 'Shahzaib Ali',
    role: 'CO-Founder',
    role2: 'Frontend Developer',
    image: '/shahzaibali.jpg',  // ✅ Corrected path
    socials: {
      linkedin: 'https://www.linkedin.com/in/shahzaib-ali-b75ba7308 ',
      twitter: 'https://x.com/ShahzaibAli7p?t=PLwBWRx3ZAtdihV9Vxb--w&s=09',
      facebook: 'https://www.facebook.com/shahzaib.ali.452015',
    },
  },  
  {
    name: 'Tasawar Ali',
    role: 'CTO',
    role2: 'Project manager',
    image: '/tasswareali.jpg',
    socials: {
     
      twitter: 'https://www.facebook.com/profile.php?id=100081897481473',
      facebook: 'https://www.facebook.com/profile.php?id=100081897481473',
      instagram: 'https://www.facebook.com/profile.php?id=100081897481473',
    },
  },
 
];

const Teams = () => {
  return (
    <div className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="text-center space-y-6 max-w-3xl mx-auto"
      >
        <h2 className="text-3xl font-semibold text-indigo-600">Meet Our Team</h2>
        <p className="text-lg text-gray-600 leading-relaxed">
          Behind every successful project at Codexa is a talented, diverse team of experts
          who are passionate about delivering excellence. Our team is made up of developers,
          designers, strategists, and project managers working in harmony to create innovative digital solutions.
        </p>
      </motion.div>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10 max-w-7xl mx-auto">
        {teamMembers.map((member, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition cursor-pointer"
          >
            <img
              src={member.image}
              alt={member.name}
              className="w-24 h-24 mx-auto rounded-full object-cover border-4 border-indigo-500"
            />
            <div className="text-center mt-4">
              <h3 className="text-xl font-semibold text-gray-800">{member.name}</h3>
              <p className="text-indigo-600">{member.role}</p>
              <p className="text-indigo-600">{member.role2}</p>
            </div>
            <div className="flex justify-center gap-4 mt-4 text-indigo-600 text-lg">
              {member.socials.linkedin && (
                <a href={member.socials.linkedin} target="_blank" rel="noopener noreferrer" title="LinkedIn">
                  <FaLinkedin className="hover:text-indigo-800 transition hover:scale-110" />
                </a>
              )}
              {member.socials.github && (
                <a href={member.socials.github} target="_blank" rel="noopener noreferrer" title="GitHub">
                  <FaGithub className="hover:text-indigo-800 transition hover:scale-110" />
                </a>
              )}
              {member.socials.twitter && (
                <a href={member.socials.twitter} target="_blank" rel="noopener noreferrer" title="Twitter">
                  <FaTwitter className="hover:text-indigo-800 transition hover:scale-110" />
                </a>
              )}
              {member.socials.facebook && (
                <a href={member.socials.facebook} target="_blank" rel="noopener noreferrer" title="Facebook">
                  <FaFacebook className="hover:text-indigo-800 transition hover:scale-110" />
                </a>
              )}
              {member.socials.instagram && (
                <a href={member.socials.instagram} target="_blank" rel="noopener noreferrer" title="Instagram">
                  <FaInstagram className="hover:text-indigo-800 transition hover:scale-110" />
                </a>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Teams;
